import { useQuery } from "react-query";

import { autoChecklistService } from "services";

const useGVerifyGAuthenticateResultQuery = ({
	id,
	enabled = true,
}: {
	id: string;
	enabled?: boolean;
}) =>
	useQuery(
		["getGVerifyGAuthenticateResult", id],
		() => autoChecklistService.getGVerifyGAuthenticateResult(id),
		{
			retry: 0,
			cacheTime: 0,
			enabled: enabled && !!id,
		},
	);

export default useGVerifyGAuthenticateResultQuery;
